import { render } from "./LogoBrandingComponent.vue?vue&type=template&id=de2aade2"
import script from "./LogoBrandingComponent.vue?vue&type=script&lang=js"
export * from "./LogoBrandingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__